import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/axios'
import './utils/meta'
import './utils/jquery'
import Pagination2 from 'vue-pagination-2'
import VModal from 'vue-js-modal'
import SocialSharing from 'vue-social-sharing'

// css
import './assets/css/notosanstc.css'
import './assets/css/bootstrap.min.css'
import './assets/css/dashboard.css'
import './assets/css/style.css'
import './assets/css/popuo-box.css'

// js
import './assets/js/bootstrap.min'
import './assets/js/jquery.magnific-popup'

Vue.config.productionTip = false
Vue.component('pagination', Pagination2)
Vue.use(VModal, { dialog: true })
Vue.use(SocialSharing)

Vue.prototype.cmsApiToken = 'testcmstoken'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
